import React from 'react';
import { ListingResource, useListingField } from '@brightmls/nextgen.lae.flc';
import UploadFile from './component/UploadFile';
import { CustomControlImplementation } from '../../../common/CustomControl';
import { FormField } from '../../FormField';
import { PropertyField } from '../../../../system/field';

/**
 * OfficeExclusiveDocument component
 */
const OfficeExclusiveDocument: React.FC<CustomControlImplementation> = ({
  field,
  fieldMeta,
  fieldPresentation,
  fieldValue,
  onFieldValueChange,
  fieldFrame,
}) => {
  const officeExclusive = useListingField(
    ListingResource.Property,
    PropertyField.OFFICE_EXCLUSIVE_YN,
    false,
  );

  const isOfficeExclusive = officeExclusive.value === true;

  if (!isOfficeExclusive) return null;

  return (
    <>
      <FormField
        field={field}
        fieldMeta={
          fieldMeta || {
            Name: 'Upload Office Exlusive Document',
          }
        }
        fieldPresentation={fieldPresentation}
        fieldValue={fieldValue}
        onFieldValueChange={onFieldValueChange}
        {...{
          ...fieldFrame,
          isRequired: true,
        }}
        showLabel
      >
        <UploadFile
          // label="Upload Office Exlusive Document"
          description="This document will not be shared outside this listing"
        />
      </FormField>
    </>
  );
};

export default OfficeExclusiveDocument;

export { useFileUpload } from './hooks';
export {
  OFFICE_EXCLUSIVE_FILENAME,
  OFFICE_EXCLUSIVE_SHORT_DESC,
  OfficeExclusiveType,
} from './types';
